import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Toasts, useCopyToClipboard } from '@fourthwall/components'
import { ShopUrlActionsMobile } from '@fourthwall/module-shop-status-switch'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'
import { routing } from '@utils/routing'

export const ShopQuickActionsMobile = () => {
  const { currentShop } = useCurrentShop()
  const { copyToClipboard } = useCopyToClipboard()

  const navigate = useNavigate()

  return (
    <ShopUrlActionsMobile
      onDuplicateClick={() => {
        if (currentShop?.baseUri) {
          copyToClipboard(currentShop.baseUri)
          Toasts.notify('Copied to clipboard', { type: 'info' })
        }
      }}
      onSettingsClick={() => {
        navigate(routing.settings.domain.self)
      }}
    />
  )
}
